import { HelmetDexteel } from "@dexteel/mesf-core";
import { CircularProgress, Grid2 as Grid } from "@mui/material";
import Paper from "@mui/material/Paper";
import { useEffect, useState } from "react";
import { getCatalogSections } from "../../repositories/CatalogSectionRepository";
import { useCatalogSectionContext } from "./CatalogSectionContext";
import { TableSection } from "./components/TableSection";

type Props = {};
export const CatalogSectionPage = (props: Props) => {
	const { state, actions } = useCatalogSectionContext();
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState("");

	const getCatalogSectionsFromAPI = async () => {
		setIsLoading(true);
		const resp = await getCatalogSections();
		if (resp.ok) {
			actions.setSections(resp.data.tables[0].rows);
			setIsLoading(false);
		} else {
			setError(resp.message);
		}
	};

	useEffect(() => {
		getCatalogSectionsFromAPI();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	if (state.sections) {
		return (
			<>
				<HelmetDexteel title="Sections - Configurations" />
				<Grid container justifyContent="center" alignItems="center">
					<Grid size={{ xs: 12 }} style={{ margin: 0 }}>
						<Paper
							elevation={0}
							style={{
								width: "100%",
								padding: "15px 20px 10px",
								borderRadius: "0.75rem",
							}}
						>
							<TableSection
								isLoading={isLoading}
								getCatalogSectionsFromAPI={getCatalogSectionsFromAPI}
							/>
						</Paper>
					</Grid>
				</Grid>
			</>
		);
	}
	return (
		<Grid
			size={{ xs: 12 }}
			style={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				height: "70vh",
			}}
		>
			<CircularProgress />
		</Grid>
	);
};
